import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ReloadRouteUtilityService } from '@app/services/reload-route/reload-route-utility.service';
import { ComponentNameService } from '@app/services/component-name.service';
import { LoginService } from '@app/services/login.service';
import { defined } from '@app/fremework/functions';
import { SessionService } from '@app/services/session/session.service';
import { SessionKeys } from './constants/session-keys';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppRouteGuard {

  private pathMatrix = new Map<any, string[]>();

  constructor(
    private reloadRouteUtilityService: ReloadRouteUtilityService,
    private readonly loginService: LoginService,
    private componentNameService: ComponentNameService,
    private sessionService: SessionService,
    private router: Router,
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {

    this.reloadRouteUtilityService.storeCurrentUrlInSessionStorage(state.url);
    return this.guard(next);
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    this.reloadRouteUtilityService.storeCurrentUrlInSessionStorage(state.url);
    return this.guard(next);
  }

  guard(next?: ActivatedRouteSnapshot): Observable<boolean> {
    const raceGuid = this.sessionService.get(SessionKeys.selectedRaceId);

    if(!defined(raceGuid)) {
      this.router.navigate(['./']);
      return of(false);
    }

    if (this.loginService.hasToken(raceGuid)) {
      this.componentNameService.currentComponentName = next.component.name;
      return of(true);
    }

    return  this.loginService.checkLogin(raceGuid)
      .pipe(map(userToken => defined(userToken)));
  }

  getResolvedUrl(route: ActivatedRouteSnapshot): string {
    return route.pathFromRoot
      .map(v => v.url.map(segment => segment.toString()).join('/'))
      .join('/');
  }

}
